module.exports = __webpack_public_path__ + "img/sprind.b141b40a.png";